import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Layout } from '../../../../../components/auth';
import { Button, Input } from '../../../../../components/common';
import { FetchStatus } from '../../../../../enums';
import { useAuth, useRegister, useResetRegisterStatus } from '../../../../../features/auth';
import { isPasswordValid } from '../../../../../utils';
import { ISignUpPasswordProps } from './types';

export const SignUpPassword = ({ email, onBack, onComplete }: ISignUpPasswordProps) => {
  const { t } = useTranslation();
  const [password, setPassword] = useState('');
  const register = useRegister();
  const resetRegisterStatus = useResetRegisterStatus();
  const {
    status: { register: registerStatus },
  } = useAuth();

  const isValid = useMemo(() => isPasswordValid(password), [password]);

  const handleRegister = useCallback(() => {
    register({ username: email, password });
  }, [email, password, register]);

  useEffect(() => {
    resetRegisterStatus();
  }, []);

  useEffect(() => {
    if (registerStatus === FetchStatus.SUCCESS) {
      resetRegisterStatus();
      onComplete();
    }
  }, [registerStatus]);

  return (
    <Layout title={t('signup.title.password')}>
      <div className="mb-6"></div>

      <Input
        value={password}
        label={t('signup.field.password.label')}
        onChange={setPassword}
        placeholder={t('signup.field.password.placeholder')}
        type="password"
        hasError={registerStatus === FetchStatus.FAILURE}
        helpLabel={t('signup.validation.password')}
      />

      <div className=" flex mt-6">
        <Button
          text={t('signup.button.create')}
          onClick={handleRegister}
          loading={registerStatus === FetchStatus.LOADING}
          disabled={!isValid}
        />
        <Button text={t('signup.button.back')} onClick={onBack} type="tertiary" className="ml-3" />
      </div>
    </Layout>
  );
};
